var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.919 33.08a6.25 6.25 0 010 8.84l-75 74.999a6.25 6.25 0 11-8.838-8.838l75-75a6.249 6.249 0 018.838 0z",
    fill: "#D50000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.08 33.08a6.25 6.25 0 018.84 0l74.999 75.001a6.249 6.249 0 010 8.838 6.249 6.249 0 01-8.838 0l-75-75a6.25 6.25 0 010-8.838z",
    fill: "#D50000"
  })));
}
export default __webpack_public_path__ + "img/_/_/views/cabinet/Feedback/assets/images/svg/failed.svg";
export { SvgFailed as ReactComponent };